
function makeAppConfig() {
    let hostname = window.location.hostname;
    let isLocal = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1');
    let devTestUrl='whr-self-registration-uat.appspot.com';
    let hostUrl = 'https://backendservice-dot-'+(isLocal?devTestUrl:hostname);

    let AppConfig = {
        brand: 'Beko Europe Partner Registration Portal',
        URL: hostUrl,
        translationUrl: '/_ah/api/noAuthApi/v1/i18nJson',
        translationVersion: 3,
        apiKey: 'AIzaSyC6hpVLEnGHyCEC-2sLZt4-AgUeil9Xdi0',
        google_client_id: '731139322915-nctt38kpf4dg8hufuo1kdaesod2dq2nd.apps.googleusercontent.com', //using prod client-id for all environments
        validNameRegex: /^[a-zA-Z0-9`$%&*_+-:,. ']+$/,
        toasterDefaultTimeOut: 2000,
        toasterDefaultPositionClass: 'toast-bottom-right',      // 'toast-top-full-width', 'toast-bottom-full-width', 'toast-center',
                                                                // 'toast-top-left', 'toast-top-center', 'toast-top-right',
                                                                // 'toast-bottom-left', 'toast-bottom-center', 'toast-bottom-right',
        toastrType: {error:'error', info:'info', wait:'wait', success:'success', warning:'warning'},
        emailPattern: /^.+@.+\..+$/,
        user: '',
        layoutBoxed: false,                             // true, false
        navCollapsed: true,                            // true, false
        navBehind: false,                               // true, false
        fixedHeader: true,                              // true, false
        sidebarWidth: 'middle',                         // small, middle, large      
        theme: 'light',                                 // light, gray, dark
        colorOption: '21',                              // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
        AutoCloseMobileNav: true,                       // true, false. Automatically close sidenav on route change (Mobile only)
        productLink: '',
        systemAdmin:'SYSTEM_ADMIN',
        regionalAdmin:'REGIONAL_ADMIN',
        BUManager: 'BU_MANAGER',
        applicationManager: 'APPLICATION_MANAGER',
        serviceOwner:'SERVICE_OWNER',
        tradePartner:'TRADE_PARTNER',
        subuser:'SUBUSER'
    };

    return AppConfig;
}

export const APPCONFIG = makeAppConfig();


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/config.ts